import PropTypes from 'prop-types';
import React from 'react';
import styles from './feed.scss';

const Feed = ({ entries }) => (
  <div className={styles.feed}>{`[Feed] entry count: ${entries.length}`}</div>
);

Feed.propTypes = {
  entries: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
export default Feed;
